<div class="loader" i18n>Loading...</div>
